export function getToken() {
  return localStorage.getItem("usertoken");
}

export function setToken(token) {
  localStorage.setItem("usertoken", token);
}

export function setNotificationToken(token) {
  localStorage.setItem("notificationtoken", token);
}

export function getNotificationToken() {
  return localStorage.getItem("notificationtoken");
}

export function deleteAll() {
  localStorage.clear();
  sessionStorage.clear();
}

export function setKneuraId(id) {
  localStorage.setItem("kneuraId", id);
}

export function getKneuraId() {
  return localStorage.getItem("kneuraId");
}

export function setUserId(id) {
  localStorage.setItem("userId", id);
}

export function getUserId() {
  return localStorage.getItem("userId");
}

export function setInstituteKneuraId(Id) {
  localStorage.setItem("instituteKneuraId", Id);
}

export function getInstituteKneuraId() {
  return localStorage.getItem("instituteKneuraId");
}

export function setInstituteId(id) {
  localStorage.setItem("instituteId", id);
}

export function getInstituteId() {
  return localStorage.getItem("instituteId");
}

export function setClassInfo(classinfo) {
  sessionStorage.setItem("classinfo", JSON.stringify(classinfo));
}

export function setClassRequestInfo(classRequestInfo) {
  sessionStorage.setItem("classRequestInfo", JSON.stringify(classRequestInfo));
}

export function setClassRequestsData(classRequestsData) {
  localStorage.setItem("classRequestsData", JSON.stringify(classRequestsData));
}

export function getClassRequestsData() {
  return JSON.parse(localStorage.getItem("classRequestsData"))
}

export function getClassInfo() {
  return JSON.parse(sessionStorage.getItem("classinfo"));
}

export function getClassRequestInfo() {
  return JSON.parse(sessionStorage.getItem("classRequestInfo"));
}

export function removeClassInfo() {
  sessionStorage.removeItem("classinfo");
}

export function setBoardInfo(boardinfo) {
  sessionStorage.setItem("boardinfo", JSON.stringify(boardinfo));
}

export function getBoardInfo() {
  return JSON.parse(sessionStorage.getItem("boardinfo"));
}

export function removeBoardInfo() {
  sessionStorage.removeItem("boardinfo");
}
export function setProfileInfo(profileinfo) {
  sessionStorage.setItem("profileinfo", JSON.stringify(profileinfo));
}

export function getProfileInfo() {
  return JSON.parse(sessionStorage.getItem("profileinfo"));
}

export function removeProfileInfo() {
  sessionStorage.removeItem("profileinfo");
}

export function setusername(name) {
  localStorage.setItem("username", name);
}

export function getusername() {
  return localStorage.getItem("username");
}

export function setFlowId(flowid) {
  localStorage.setItem("flowid", flowid);
}

export function getFlowId() {
  return localStorage.getItem("flowid");
}

export function setUserRole(userRole) {
  localStorage.setItem("userRole", userRole);
}

export function getUserRole() {
  return localStorage.getItem("userRole");
}
export function getCbmsToken() {
  console.log("FETCHING CBMS TOKEN",localStorage.getItem('cbms_token'))
  return localStorage.getItem('cbms_token');
}
export function setCbmsToken(value) {
  console.log("SETTING CBMS TOKEN",value)
  return localStorage.setItem('cbms_token',value);
}
export function setShouldTakeAttendanceOption(value = true) {
  sessionStorage.setItem('takeAttendance',JSON.parse(value) );
}
export function getShouldTakeAttendanceOption() {
  return sessionStorage.getItem('takeAttendance');
}